export const ACTION_ADD_CAMPAIGNS_STATS = 'ACTION_ADD_CAMPAIGNS_STATS';
